<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="." class="logo">
                        <img src="images/logo.png" alt="logo">
                        <h3 class="mt-2">SUCCESS PARAMEDICAL INSTITUTE</h3>
                        <!-- <h3 class="mt-2">THE MOST TRUSTED PARAMEDICAL INSTITUTE in SURAT</h3> -->
                    </a>
                    <!-- <p>Working to bring significant changes in online-based learning by doing extensive research for
                        course curriculum preparation, student engagements, and looking forward to the flexible
                        education!</p> -->
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/share/1Z3NKD3iQV/" class="d-block" target="_blank"><i
                                    class="fa-brands fa-facebook-f white-icon"></i></a></li>
                        <!-- <li><a routerLink="" class="d-block" target="_blank"><i
                                    class="fa-brands fa-x-twitter white-icon"></i></a></li> -->
                        <li><a href="https://www.instagram.com/successparamedical?igsh=MXBicjlmcnEzc2g4MQ=="
                                class="d-block" target="_blank"><i class="fa-brands fa-instagram white-icon"></i></a>
                        </li>
                        <!-- <li><a routerLink="" class="d-block" target="_blank"><i
                                    class="fa-brands fa-linkedin-in white-icon"></i></a>
                        </li> -->
                        <li><a href="tel:+919924018454" class="d-block" target="_blank"><i
                                    class="fa-brands fa-whatsapp white-icon"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Explore</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/home">Home</a></li>
                        <li><a routerLink="/about-us">About us</a></li>
                        <li><a routerLink="/courses-category">Courses</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                        <li><a routerLink="/admin/authentication/admin-login">Admin</a></li>
                        <!-- <li><a routerLink="/admin/dashboard">Admin-Dashboard</a></li> -->
                    </ul>
                </div>
            </div>
            <!-- <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Resources</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="">Student Success</a></li>
                        <li><a routerLink="">Scholarships</a></li>
                        <li><a routerLink="">For Business</a></li>
                        <li><a routerLink="">Go Premium</a></li>
                        <li><a routerLink="">Team Plans</a></li>
                        <li><a routerLink="/admin/authentication/admin-login">Admin-Login</a></li>
                        <li><a routerLink="/admin/dashboard">Admin-Dashboard</a></li>
                    </ul>
                </div>
            </div> -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Address</h3>
                    <ul class="footer-contact-info">
                        <li><i class="fa-solid fa-location-dot white-icon"></i> Head Office <br>
                            Samrat Nagar Society, Kapodra, varachha,
                            Surat-395009
                        </li>
                        <li><i class="fa-solid fa-location-dot white-icon"></i>Branch 1 <br>
                            Bardoli
                        </li>
                        <li><i class="fa-solid fa-location-dot white-icon"></i>Branch 2 <br>
                            Ankleshwar
                        </li>
                        <li><i class="fa-solid fa-phone white-icon"></i><a href="tel:+919924018454">+91 99240
                                18454</a>
                        </li>
                        <li><i class="fa-solid fa-envelope white-icon"></i><a
                                href="mailto:successparamedicalinstitute8&#64;gmail.com">successparamedicalinstitute8&#64;gmail.com</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>Copyright © 2025 No.1 Medical Institute <br> Powered by No.1 Medical Institute.</p>
                </div>
                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="">Privacy Policy</a></li>
                        <li><a routerLink="">Terms & Conditions</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div> -->
</footer>